export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
  logoutButton: "logout-button",
  error: "login-error",
};

export const NAV = {
  dashboard: "nav-dashboard",
  upload: "nav-upload",
  review: "nav-review",
  history: "nav-history",
  reports: "nav-reports",
  settings: "nav-settings",
  outletSwitcher: "outlet-switcher",
  themeToggle: "theme-toggle",
  quickUpload: "nav-quick-upload",
  bell: "notification-bell",
};

export const UPLOAD = {
  outletSelect: "upload-outlet-select",
  fileInput: "upload-receipt-input",
  dropzone: "upload-dropzone",
  submit: "upload-submit-button",
  card: "upload-receipt-card",
};

export const REVIEW = {
  list: "review-list",
  card: "review-card",
  zoomIn: "review-zoom-in",
  zoomOut: "review-zoom-out",
  rotate: "review-rotate",
  reset: "review-zoom-reset",
  brightness: "review-brightness",
  addItem: "review-add-item",
  saveDraft: "review-save-draft",
  reject: "review-reject-button",
  approve: "review-approve-button",
  varianceNote: "review-variance-note",
  varianceConfirm: "review-variance-confirm",
  reprocess: "review-reprocess-button",
};

export const HISTORY = {
  table: "history-table",
  row: "history-row",
  statusFilter: "history-status-filter",
  export: "history-export-button",
};

export const SETTINGS = {
  tabOutlets: "settings-tab-outlets",
  tabItems: "settings-tab-items",
  tabUsers: "settings-tab-users",
  tabDaily: "settings-tab-daily",
  addOutlet: "settings-add-outlet",
  addItem: "settings-add-item",
  addUser: "settings-add-user",
  uploadTemplate: "settings-upload-template",
};
